import React from 'react'
import MediaQuery from 'react-responsive'

const breakpoints = {
  desktop: '(min-width: 1024px)',
  tablet: '(min-width: 768px) and (max-width: 1023px)',
  phone: '(max-width: 767px)',
  xs: '(max-width: 575px)',
  smUp: '(min-width: 576px)',
  sm: '(min-width: 576px) and (max-width: 767px)',
  smDown: '(max-width: 767px)',
  mdUp: '(min-width: 768px)',
  md: '(min-width: 768px) and (max-width: 991px)',
  mdDown: '(max-width: 991px)',
  lgUp: '(min-width: 992px)',
  lg: '(min-width: 992px) and (max-width: 1199px)',
  lgDown: '(max-width: 1199px)',
  xl: '(min-width: 1200px)',
}

export default function Breakpoint(props) {
  const breakpoint = breakpoints[props.query] || breakpoints.desktop
  
  return (
    <MediaQuery {...props} query={breakpoint}>
      {props.children}
    </MediaQuery>
  )
}



// WEBPACK FOOTER //
// ./src/responsive-utilities/breakpoint.js